import { toastService } from '@thefarmersfront/kitchen';

import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT, TOAST_MESSAGE } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePatchVendorReleaseStatusParams } from '~/types/stock.types';

/**
 * [재고관리] 반출 상태 변경 api 요청 훅
 */
const usePatchVendorReleaseStatus = () => {
  const { runAsync } = useAsyncHandler();

  const patchVendorReleaseStatus = useAPI<TypePatchVendorReleaseStatusParams>({
    endpoint: API_ENDPOINT.STOCK.POST_VENDOR_RELEASE_STATUS,
    method: 'patch',
  });

  /** 반출 요청 취소 요청 */
  const requestVendorReleaseCancel = async (
    idList: number[],
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: () => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    } = {}
  ) => {
    const params: TypePatchVendorReleaseStatusParams = {
      idList,
      status: 'CANCEL',
    };

    runAsync(() => patchVendorReleaseStatus({ params }), {
      onSuccess: () => {
        toastService.addToast({
          message: '반출 요청이 취소되었습니다.',
        });
        onSuccess?.();
      },
      onError: (error: TypeErrorResponseData['error']) => {
        toastService.addToast({
          type: 'error',
          message: error.message ?? TOAST_MESSAGE.DEFAULT_ERROR,
        });
        onError?.(error);
      },
    });
  };

  return { requestVendorReleaseCancel };
};

export default usePatchVendorReleaseStatus;
